import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { getFullURL, isMobileDevice } from './shareUtils';

export const WhatsAppButton = ({ url, title, text, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const shareUrl = url || getFullURL();
  const shareText = text ? `${text} ${shareUrl}` : shareUrl;
  const isMobile = isMobileDevice();

  const handleShare = () => {
    // For mobile devices - use different URL formats
    if (isMobile) {
      // On mobile, can try to use native sharing if available
      if (navigator.share && navigator.canShare) {
        // Try Web Share API first if available (modern mobile browsers)
        try {
          navigator
            .share({
              title: title,
              text: shareText,
              url: shareUrl,
            })
            .catch(error => {
              // Fallback to WhatsApp URL scheme if Web Share API fails
              const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(shareText)}`;
              window.location.href = whatsappUrl;
            });
          return;
        } catch (error) {
          console.error('Error sharing via Web Share API:', error);
        }
      }

      // For older mobile browsers or if Web Share API fails
      // Use direct WhatsApp URL scheme that works better on mobile
      const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(shareText)}`;
      window.location.href = whatsappUrl;
    } else {
      // For desktop - use the API URL format
      const whatsappUrl = `https://api.whatsapp.com/send/?text=${encodeURIComponent(
        shareText
      )}&type=custom_url&app_absent=0`;
      window.open(whatsappUrl, '_blank');
    }
  };

  return (
    <ShareButtonBase
      icon={<WhatsAppIcon />}
      label={intl.formatMessage({ id: 'ShareActions.whatsApp', defaultMessage: 'WhatsApp' })}
      url={shareUrl}
      onClick={handleShare}
      title={title}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      text={text}
      {...rest}
    />
  );
};

WhatsAppButton.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

WhatsAppButton.defaultProps = {
  url: '',
  title: 'Check this out',
  text: '',
};
